import { Chip } from "@mui/material";
import { ReactNode } from "react";

export type BadgeTone = "ok" | "warn" | "info" | "danger" | "neutral";

const TONE_COLOR: Record<BadgeTone, string> = {
  ok: "success.main",
  warn: "warning.main",
  info: "info.main",
  danger: "error.main",
  neutral: "text.secondary",
};

interface Props {
  tone?: BadgeTone;
  children: ReactNode;
}

export const Badge = ({ tone = "neutral", children }: Props) => (
  <Chip
    label={children}
    size="small"
    sx={{
      bgcolor: "transparent",
      border: "1px solid",
      borderColor: TONE_COLOR[tone],
      color: TONE_COLOR[tone],
      fontWeight: 600,
      fontSize: 11,
    }}
  />
);
